export default __webpack_public_path__ + "static/media/map2.09254705.png";